import { formatPublishDate } from './dateutils';

const isNotMobileView = window.innerWidth > 890;

// different view depend on items count
export const resizeBlogList = () => {
  const getBlogItems = document.querySelectorAll('.blog-item');

  if (isNotMobileView && getBlogItems) {
    if (getBlogItems.length % 2 === 0) {
      [...getBlogItems].forEach((item) => item.classList.add('two-in-row'));
    }
    if (getBlogItems.length % 3 === 0) {
      [...getBlogItems].forEach((item) => item.classList.add('three-in-row'));
    }
  }
};

// remove pagination button when it's first/last page
export const removePaginationsButtons = () => {
  const nextButton = document.querySelector('.pagination-next');
  const prvButton = document.querySelector('.pagination-previous');
  if (nextButton || prvButton) {
    if (nextButton.textContent === '') {
      nextButton.parentNode.removeChild(nextButton);
    }
    if (prvButton.textContent === '') {
      prvButton.parentNode.removeChild(prvButton);
    }
  }
};

// function to handle adding/removing class
export const toggleClass = (element, className, callback) => {
  if (element.classList.contains(className)) {
    element.classList.remove(className);
    callback && callback();
    return removeEventListener('click', toggleClass);
  }
  element.classList.add(className);
  callback && callback();
};

// accordion the achive widget
const toggleArchiveYearSection = () => {
  const archiveSection = document.querySelectorAll('.archive-month');
  if (archiveSection) {
    [...archiveSection].forEach((sec, ind) => {
      const list = sec.nextElementSibling.querySelector('.months-list');

      sec.addEventListener('click', () => {
        toggleClass(sec, 'isOpened', toggleClass(list, 'show'));
      });
    });
  }
};

// accordion specific section in achive
export const toggleArchiveSection = () => {
  const archiveSection = document.querySelector('.sidebar-articles-archive');
  const archiveTitle = document.querySelector(
    '.sidebar-articles-archive .toggle-tittle'
  );
  if (archiveTitle) {
    archiveTitle.addEventListener('click', () => {
      toggleClass(archiveSection, 'opened', toggleArchiveYearSection);
    });
  }
};

export const formatAtlWidgetDate = () => {
  const articlesDate = document.querySelectorAll(
    '.atl-article-widget .article-time'
  );
  if (articlesDate) {
    [...articlesDate].forEach((article) => {
      const newDate = formatPublishDate(article.textContent);
      article.textContent = newDate;
    });
  }
};
